import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsform',
	templateUrl:'./BSFormPage.html',
	styles: [],
	styleUrls:['./BSFormPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSFormPage
{
	mdContent_112 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.forms.BSForm;
\`\`\``;
	mdContent_113 = `\`\`\`java
new BSForm<>(String id, INgServiceProvider<?> formDataProvider)
\`\`\``;
	mdContent_114 = `\`\`\`java
var form = new BSForm<>("loginForm", myDataProvider);

var email = form.createEmailInput("email", "Email Address");
form.add(email);

var pwd = form.createPasswordInput("password", "Password", true);
form.add(pwd);

var submit = form.createSubmitButton();
submit.setText("Sign In");
submit.setPrimary(true);
form.add(submit);
\`\`\``;
}
